import { ThreatenContent } from '@/components/ThreatenContent/ThreatenContent'
import { WarnemContent } from '@/components/WarnemContent/WarnemContent'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import { useToken } from '@/hooks/useToken'
import { usePremiumFeaturesPaymentIssue } from '@/stores/permissions/premiumFeatures'
import { App } from 'antd'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export function usePaymentStatusWarnings() {
  const { t: tUtils } = useTranslation(undefined, { keyPrefix: 'utils' })
  const { t } = useTranslation()
  const ref = useRef<boolean>(false)
  const { token } = useToken()

  const { modal } = App.useApp()

  const shouldEnforceBillingFoundations = useFlag(
    DashboardExperiments.shouldEnforceBillingFoundations,
  )

  const premiumFeaturesPaymentIssue = usePremiumFeaturesPaymentIssue()

  const shouldWarn = premiumFeaturesPaymentIssue?.shouldWarn
  const shouldThreat = premiumFeaturesPaymentIssue?.shouldThreat
  const gracePeriod = premiumFeaturesPaymentIssue?.gracePeriod

  useEffect(() => {
    if (ref.current) {
      return
    }

    if (shouldEnforceBillingFoundations && premiumFeaturesPaymentIssue) {
      ref.current = true

      if (shouldWarn) {
        modal.confirm({
          centered: true,
          okButtonProps: {
            style: {
              backgroundColor: token.colorPrimary,
              color: token.colorTextLightSolid,
            },
          },
          title: t(`components.modals.paymentStatusWarnings.warnem.title`),
          content: <WarnemContent gracePeriod={gracePeriod} />,
          okText: t(`components.modals.paymentStatusWarnings.okText`),
          onOk: () => {
            window.open(t(`pages.accountSuspended.billingAddress`), '_blank')
          },
        })
      }

      if (shouldThreat)
        modal.error({
          centered: true,
          okButtonProps: {
            style: {
              backgroundColor: token.colorError,
              color: token.colorTextLightSolid,
            },
          },
          autoFocusButton: null,
          title: t(`components.modals.paymentStatusWarnings.threaten.title`),
          content: <ThreatenContent gracePeriod={gracePeriod} />,
          okText: t(`components.modals.paymentStatusWarnings.okText`),
          onOk: () => {
            window.open(t(`pages.accountSuspended.billingAddress`), '_blank')
          },
        })
    }
  }, [
    gracePeriod,
    shouldThreat,
    shouldWarn,
    premiumFeaturesPaymentIssue,
    t,
    tUtils,
    token,
    shouldEnforceBillingFoundations,
    modal,
  ])
}
